import { DetailPageActions, DetailPageActionTypes } from '../actions'
import { Reducer } from 'redux'
import { PlayerCapabilities } from 'ATVWebPlayer'
import { PlaybackContentLink } from '../integrations/playerIntegration'

export type Player = {
  playbackLinkData: PlaybackContentLink | null
  capabilities: PlayerCapabilities | null
}

const initialState = { playbackLinkData: null, capabilities: null } as Player

export const reducer: Reducer<Player, DetailPageActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.PlaybackStart:
      return state.playbackLinkData
        ? state
        : { ...state, playbackLinkData: action.payload }
    case DetailPageActionTypes.PlaybackClosed:
    case DetailPageActionTypes.PlaybackFailed:
      return { ...state, playbackLinkData: null }
    case DetailPageActionTypes.SetPlayerCapabilities:
      return { ...state, capabilities: action.payload.capabilities }
    default:
      return state
  }
}
